<script>
export default {
  props: {
    inbox: {
      type: Object,
      required: true,
    },
    inboxTypes: {
      type: Object,
      required: true,
    },
    getInboxStatusColor: {
      type: Function,
      required: true,
    },
    getInboxStatusText: {
      type: Function,
      required: true,
    },
  },
};
</script>

<template>
  <router-link
    v-slot="{ href, isActive, navigate }"
    :to="inbox.toState"
    custom
  >
    <a
      :href="href"
      class="flex mt-1 items-center gap-3 px-4 py-2 rounded-lg text-primary-100 hover:bg-primary-900/40 transition-colors"
      :class="{ 'bg-primary-900/40 text-white': isActive }"
      @click="navigate"
    >
      <fluent-icon
        v-if="inbox.type === inboxTypes.WHATSAPP"
        icon="brand-whatsapp"
        class="w-4 h-4 text-green-500 flex-shrink-0"
      />
      <fluent-icon
        v-else-if="inbox.type === inboxTypes.FACEBOOK"
        icon="brand-facebook"
        class="w-4 h-4 text-woot-600 flex-shrink-0"
      />
      <fluent-icon
        v-else-if="inbox.type === inboxTypes.INSTAGRAM"
        icon="brand-instagram"
        class="w-4 h-4 text-pink-500 flex-shrink-0"
      />
      <fluent-icon
        v-else-if="inbox.type === inboxTypes.LINE"
        icon="brand-line"
        class="w-4 h-4 text-green-600 flex-shrink-0"
      />
      <fluent-icon
        v-else-if="inbox.type === inboxTypes.SMS"
        icon="chat-warning"
        class="w-4 h-4 text-orange-500 flex-shrink-0"
      />
      <fluent-icon
        v-else-if="inbox.type === inboxTypes.API"
        icon="code"
        class="w-4 h-4 text-primary-400 flex-shrink-0"
      />
      <fluent-icon
        v-else-if="inbox.type === inboxTypes.EMAIL"
        icon="mail"
        class="w-4 h-4 text-woot-400 flex-shrink-0"
      />
      <fluent-icon
        v-else-if="inbox.type === inboxTypes.WEB"
        icon="globe"
        class="w-4 h-4 text-woot-500 flex-shrink-0"
      />
      <span
        v-else-if="inbox.color"
        class="w-3 h-3 rounded-sm flex-shrink-0"
        :style="{ backgroundColor: inbox.color }"
      />
      <div class="flex flex-col min-w-0 overflow-hidden">
        <span class="font-medium truncate">{{ inbox.label }}</span>
        <span
          v-if="inbox.type === inboxTypes.WHATSAPP && inbox.provider === 'uazapi'"
          class="text-xxs truncate"
          :class="getInboxStatusColor(inbox.instanceStatus || 'error')"
        >
          {{ getInboxStatusText(inbox.instanceStatus) }}
        </span>
      </div>
    </a>
  </router-link>
</template>
